module.exports = __webpack_public_path__ + "static/media/logo.e63a1003.png";